<template>
  <layout-header />
  <layout-sidebar />

  <div class="page-wrapper">
    <div class="content">
      <div class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div class="d-flex my-xl-auto right-content align-items-center flex-wrap">
          <div class="me-2 mb-2">
            <div class="d-flex align-items-center border bg-white rounded p-1 me-2">
              <router-link :to="{ name: 'crm.companies.list' }" class="btn btn-icon btn-sm active bg-primary text-white me-1">
                <i class="ti ti-list-tree"></i>
              </router-link>
              <router-link :to="{ name: 'crm.companies.grid' }" class="btn btn-icon btn-sm">
                <i class="ti ti-layout-grid"></i>
              </router-link>
            </div>
          </div>
          <div class="me-2 mb-2">
            <button class="btn btn-white d-inline-flex align-items-center" type="button" @click="refreshCompanies">
              <i class="ti ti-refresh me-1"></i>Refresh
            </button>
          </div>
          <div class="ms-2 head-icons">
            <a
              href="javascript:void(0);"
              id="collapse-header"
              @click="toggleHeader"
            >
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
          <h5>Companies List</h5>
          <div class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
            <div class="me-3">
              <input
                v-model.trim="search"
                type="text"
                class="form-control"
                placeholder="Search company, email, or phone"
              />
            </div>
            <div class="me-3">
              <select v-model="statusFilter" class="form-select">
                <option value="">All statuses</option>
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
                <option value="Suspended">Suspended</option>
              </select>
            </div>
            <div>
              <select v-model="sortBy" class="form-select">
                <option value="recent">Recently Added</option>
                <option value="name_asc">Name A-Z</option>
                <option value="name_desc">Name Z-A</option>
              </select>
            </div>
          </div>
        </div>
        <div class="card-body p-0">
          <div class="px-3 py-2 border-bottom bg-light d-flex align-items-center justify-content-between">
            <small class="text-muted">{{ filteredCountLabel }}</small>
            <small class="text-muted">CRM companies are read-only here.</small>
          </div>
          <div class="custom-datatable-filter table-responsive">
            <company-table :rows="filteredCompanies" :loading="companyStore.loading" />
          </div>
        </div>
      </div>
    </div>

    <div class="footer d-sm-flex align-items-center justify-content-between bg-white p-3">
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by <a href="#" @click.prevent class="text-primary">DoneQuick Technological World</a>
      </p>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import { useCompanyStore } from "@/stores/companyStore";

const title = ref("Companies");
const text = ref("CRM");
const text1 = ref("Companies List");

const companyStore = useCompanyStore();
const search = ref("");
const statusFilter = ref("");
const sortBy = ref("recent");

const filteredCompanies = computed(() => {
  let companies = [...(companyStore.companies || [])];

  if (search.value) {
    const needle = search.value.toLowerCase();
    companies = companies.filter((company) =>
      [company.company_name, company.email, company.phone, company.phone_two]
        .filter(Boolean)
        .some((value) => String(value).toLowerCase().includes(needle))
    );
  }

  if (statusFilter.value) {
    companies = companies.filter((company) => company.status === statusFilter.value);
  }

  switch (sortBy.value) {
    case "name_asc":
      companies.sort((a, b) => String(a.company_name || "").localeCompare(String(b.company_name || "")));
      break;
    case "name_desc":
      companies.sort((a, b) => String(b.company_name || "").localeCompare(String(a.company_name || "")));
      break;
    default:
      companies.sort((a, b) => new Date(b.created_at || 0) - new Date(a.created_at || 0));
      break;
  }

  return companies;
});

const filteredCountLabel = computed(() => {
  const total = companyStore.companies.length;
  const filtered = filteredCompanies.value.length;
  return filtered === total ? `${total} companies` : `${filtered} of ${total} companies`;
});

async function refreshCompanies() {
  await companyStore.fetchCompanies({ all: true });
}

function toggleHeader() {
  document.getElementById("collapse-header")?.classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

onMounted(async () => {
  await refreshCompanies();
});
</script>


